// import components
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';

// import from react
import { useState } from 'react';

// import styles
import {
  StyledContextMenuBox,
  StyledContextMenuButton
} from './ContextMenu.styles';

// import types
import { ContextMenuProps } from './ContextMenu.types';

export default function ContextMenu({
  options,
  onOptionClick,
  onOpen,
  clickType = 'lmb',
  sx,
  menuSx,
  cursorPosition = null
}: ContextMenuProps) {
  const [anchorEl, setAnchorEl] = useState<SVGElement | null>(null);
  const open = Boolean(anchorEl);

  const onClickHandler = clickType === 'lmb' ? 'onClick' : 'onContextMenu';

  function handleOpen(e: React.MouseEvent<SVGElement>) {
    e.stopPropagation();
    e.preventDefault();
    onOpen?.(true, e);
    setAnchorEl(e.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
    onOpen?.(false);
  }

  function handleMenuItemClick(option) {
    onOptionClick(option);
    handleClose();
  }

  if (options.length == 0) {
    return null;
  }

  return (
    <StyledContextMenuBox sx={sx}>
      <StyledContextMenuButton {...{ [onClickHandler]: handleOpen }}>
        <MoreVertIcon fontSize="small" />
      </StyledContextMenuButton>
      {open && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={menuSx}
          anchorReference={cursorPosition ? 'anchorPosition' : undefined}
          anchorPosition={
            cursorPosition !== null
              ? { top: cursorPosition.y, left: cursorPosition.x }
              : undefined
          }
        >
          {options.map((option) => (
            <MenuItem key={option} onClick={() => handleMenuItemClick(option)}>
              {option}
            </MenuItem>
          ))}
        </Menu>
      )}
    </StyledContextMenuBox>
  );
}
